import { Button, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box/Box";
import styled from "styled-components";

type InfoCardButtonProps = {
  customtextcolor?: string;
};

export const Container = styled(Box)`
  width: 100%;
  height: fit-content;
  flex-shrink: 0;
  border-radius: 10px 10px 10px 10px;
  background: #f4f4f4;
  transform: translateY(-48px);
`;

export const Header = styled(Box)`
  width: 100%;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px 10px 0px 0px;
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const TitleWrapper = styled(Box)`
  width: 100%;
  display: flex;
  padding-left: 10px;
  justify-content: center;
`;

export const CardTitle = styled(Typography)`
  color: var(--colours-primary-rkbt-black, #1d1d1d);
  text-align: center;
  font-family: "Outfit-SemiBold";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
`;

export const Content = styled(Box)`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  align-items: center;
  gap: 10px;
  border-radius: 0px 0px 10px 10px;
  padding: 5px 18px;
  background: var(--colours-primary-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
`;

export const Info = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FooterInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const FeesInfoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 18px;
`;

export const ActionWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Footer = styled(Box)`
  width: 100%;
  margin-top: 20px;
`;

export const FooterWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding-top: 5px;
  align-items: center;
  gap: 10px;
`;

export const InfoCardButton = styled(Button)<InfoCardButtonProps>`
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  color: ${(props) =>
    props.customtextcolor || "var(--colours-teal-600, #129479)"};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  flex: 1 0 0;
  border-radius: 6px;
  border: 2px solid var(--colours-teal-600, #129479);
  text-transform: none;
`;

export const GameDetailTypography = styled(Typography)`
  color: rgba(0, 0, 0, 0.41);
  font-family: "NotoSans-Medium";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const DetailFooterWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InfoWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
`;

export const ResultWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  width: 100%;
`;

export const ScoreWrapper = styled(Box)`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ViewScoreWrapper = styled(Box)`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const ScoreTextField = styled(TextField)`
  width: 55px;
  display: flex;
  justify-content: center;
`;

export const RatingWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const RatingMessage = styled(Typography)`
  color: rgba(0, 0, 0, 0.49);
  font-family: "NotoSans-Medium";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const UnRatedMessage = styled(Typography)`
  color: rgba(0, 0, 0, 0.49);
  font-family: "NotoSans-Medium";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 166.667% */
`;

export const Rating = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Medium";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 166.667% */
`;

export const InfoContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding-bottom: 12px;
  width: 100%;
`;

export const FeesAndCurrencyWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export const Score = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Medium";
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 120% */
`;

export const CardActionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

export const Wrapper = styled(Box)`
  display: flex;
  width: 100%;
  gap: 15px;
  justify-content: center;
  align-items: center;
`;

export const EditButton = styled(Button)`
  border-radius: 6px;
  border: 2px solid #36bba0;
  text-transform: none;
  font-family: "Outfit-SemiBold";
  font-size: 16px;
`;

export const DateWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const InfoIconWrapper = styled(Box)`
  padding-right: 10px;
  right: 10px;
  cursor: pointer;
`;

export const CurrencyWrapper = styled(Box)<{ isPound: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.isPound ? "row-reverse" : "row")};
`;
